export default "__VITE_ASSET__C4i3gdrF__"